import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shortNumber' })
export class ShortNumberPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value === null || value === undefined) return '';

    if (typeof value === 'string' && /[-–]/.test(value)) {
      const parts = value.split(/[-–]/).map(p => p.trim()).filter(Boolean);
      if (parts.length === 2) {
        const aNum = this.parseShort(parts[0]);
        const bNum = this.parseShort(parts[1]);
        if (aNum !== null && bNum !== null) {
          return `${this.formatShort(aNum)} - ${this.formatShort(bNum)}`;
        }
        return value.trim();
      }
    }

    const num = typeof value === 'number' ? value : this.parseShort(value);
    if (num === null || isNaN(num)) return '';

    return this.formatShort(num);
  }

  private parseShort(input: string): number | null {
    if (typeof input !== 'string') return null;
    let s = input.trim();
    s = s.replace(/,/g, '').replace(/\s+/g, ' ');

    if (/^[+-]?\d*(?:\.\d+)?$/.test(s)) {
      const n = parseFloat(s || '0');
      return isNaN(n) ? null : n;
    }

    const m = s.toLowerCase().match(/^([+-]?\d*(?:\.\d+)?)\s*(k|m|mio|million|millions)?$/i);
    if (!m) return null;

    const numStr = m[1] || '0';
    const unit = (m[2] || '').toLowerCase();
    let n = parseFloat(numStr);
    if (isNaN(n)) return null;

    switch (unit) {
      case 'k':
        n *= 1_000;
        break;
      case 'm':
      case 'mio':
      case 'million':
      case 'millions':
        n *= 1_000_000;
        break;
    }
    return n;
  }

  private formatShort(num: number): string {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + ' Mio';
    }
    if (num >= 1_000 || num <= -1_000) {
      return (num / 1_000).toFixed(1).replace(/\.0$/, '') + ' K';
    }
    if (Number.isInteger(num)) return String(num);
    return num.toFixed(1).replace(/\.0$/, '');
  }
}
